/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { shifts_AvailabilityWindowResponse } from './shifts_AvailabilityWindowResponse';
export type shifts_AvailabilityWarningResponse = {
    /**
     * unavailable_rule: outside an available window or inside an unavailable one. blocked_day: the employee blocked the whole day.
     */
    kind: shifts_AvailabilityWarningResponse.kind;
    /**
     * The employee's note on a blocked day
     */
    note?: string;
    /**
     * The shift's date (YYYY-MM-DD)
     */
    shift_date: string;
    /**
     * ISO weekday of shift_date, 1 = Monday ... 7 = Sunday
     */
    weekday: number;
    /**
     * Every window of that weekday in start order (unavailable_rule); empty for blocked_day
     */
    windows: Array<shifts_AvailabilityWindowResponse>;
};
export namespace shifts_AvailabilityWarningResponse {
    /**
     * unavailable_rule: outside an available window or inside an unavailable one. blocked_day: the employee blocked the whole day.
     */
    export enum kind {
        UNAVAILABLE_RULE = 'unavailable_rule',
        BLOCKED_DAY = 'blocked_day',
    }
}

